import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  body: {
    incomingBalanceId: null,
    amount: null,
    isAnonymous: false,
    userInfo: {
      firstName: "",
      lastName: "",
      email: "",
    },
    savePaymentMethod: false,
    coverFees: false,
    campaignId: "",
  },
  campaignThankOpen: false,
  communityThankOpen: false,
  allThankOpen: false,
  stripeOpen: false,
  stripeOpenDonateAll: false,
  donationFormOpen: false,
  userInfoError: true,
  joinCommunity: true,
  transferBalance: false,
  autoDonateOpen: false,
};

const donationSlice = createSlice({
  name: "donation",
  initialState: initialState,
  reducers: {
    setAutoDonateOpen(state, action) {
      state.autoDonateOpen = action.payload;
    },
    setTransferBalance(state, action) {
      state.transferBalance = action.payload;
    },
    setDonationBody(state, action) {
      state.body = action.payload;
    },
    setCampaignThankOpen(state, action) {
      state.campaignThankOpen = action.payload;
    },
    setCommunityThankOpen(state, action) {
      state.communityThankOpen = action.payload;
    },
    setAllThankOpen(state, action) {
      state.allThankOpen = action.payload;
    },
    setStripeOpen(state, action) {
      state.stripeOpen = action.payload;
    },
    setStripeOpenDonateAll(state, action) {
      state.stripeOpenDonateAll = action.payload;
    },
    setDonationFormOpen(state, action) {
      state.donationFormOpen = action.payload;
    },
    setUserFirstName(state, action) {
      state.body.userInfo.firstName = action.payload;
    },
    setUserLastName(state, action) {
      state.body.userInfo.lastName = action.payload;
    },
    setUserEmail(state, action) {
      state.body.userInfo.email = action.payload;
    },
    setUserInfoError(state, action) {
      state.userInfoError = action.payload;
    },
    setJoinCommunity(state, action) {
      state.joinCommunity = action.payload;
    },
  },
});

export const {
  setDonationBody,
  setAllThankOpen,
  setCampaignThankOpen,
  setCommunityThankOpen,
  setStripeOpen,
  setDonationFormOpen,
  setUserFirstName,
  setUserLastName,
  setUserEmail,
  setUserInfoError,
  setJoinCommunity,
  setStripeOpenDonateAll,
  setTransferBalance,
  setAutoDonateOpen,
} = donationSlice.actions;
export default donationSlice.reducer;
